/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { adminv3_ChatbotTestExecutionResponse } from "../models/adminv3_ChatbotTestExecutionResponse"
import type { adminv3_CreateChatbotTestExecutionRequest } from "../models/adminv3_CreateChatbotTestExecutionRequest"
import type { adminv3_UpdateChatbotTestExecutionRequest } from "../models/adminv3_UpdateChatbotTestExecutionRequest"
import type { avy_api_internal_avyframework_avyhttp_ListRequest } from "../models/avy_api_internal_avyframework_avyhttp_ListRequest"
import type { avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestExecutionResponse } from "../models/avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestExecutionResponse"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class ChatbotTestExecutionService {
    /**
     * Create a new chatbot test execution
     * Create a new chatbot test execution with the provided details
     * @returns adminv3_ChatbotTestExecutionResponse Created
     * @throws ApiError
     */
    public static postV3AdminChatbotTestExecution({
        request,
    }: {
        /** Create Chatbot Test Execution Request **/
        request: adminv3_CreateChatbotTestExecutionRequest
    }): CancelablePromise<adminv3_ChatbotTestExecutionResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/chatbot-test-execution",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * List chatbot test executions
     * List chatbot test executions with pagination and filtering
     * @returns avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestExecutionResponse OK
     * @throws ApiError
     */
    public static postV3AdminChatbotTestExecutionList({
        request,
    }: {
        /** Chatbot test execution list request **/
        request: avy_api_internal_avyframework_avyhttp_ListRequest
    }): CancelablePromise<avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestExecutionResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/chatbot-test-execution/list",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Get chatbot test execution
     * Get a single chatbot test execution by ID
     * @returns adminv3_ChatbotTestExecutionResponse OK
     * @throws ApiError
     */
    public static getV3AdminChatbotTestExecution({
        id,
    }: {
        /** Chatbot Test Execution ID **/
        id: number
    }): CancelablePromise<adminv3_ChatbotTestExecutionResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v3/admin/chatbot-test-execution/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Update chatbot test execution
     * Update a single chatbot test execution by ID
     * @returns adminv3_ChatbotTestExecutionResponse OK
     * @throws ApiError
     */
    public static putV3AdminChatbotTestExecution({
        id,
        request,
    }: {
        /** Chatbot Test Execution ID **/
        id: number
        /** Update Chatbot Test Execution Request **/
        request: adminv3_UpdateChatbotTestExecutionRequest
    }): CancelablePromise<adminv3_ChatbotTestExecutionResponse> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/v3/admin/chatbot-test-execution/{id}",
            path: {
                id: id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Delete chatbot test execution
     * Delete a single chatbot test execution by ID
     * @returns any OK
     * @throws ApiError
     */
    public static deleteV3AdminChatbotTestExecution({
        id,
    }: {
        /** Chatbot Test Execution ID **/
        id: number
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/v3/admin/chatbot-test-execution/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }
}
